import {FC, ReactNode} from 'react'

type PropsWithChildrenAndId = {
  children: ReactNode
  id?: string
}

const Heading1: FC<PropsWithChildrenAndId> = ({children, id}) => {
  return (
    <h1 id={id} className="mt-8 py-4 text-display-sm font-medium">
      {children}
    </h1>
  )
}
Heading1.displayName = 'Heading1'

const Heading2: FC<PropsWithChildrenAndId> = ({children, id}) => {
  return (
    <h2 id={id} className="mt-4 py-2 text-display-xs font-regular">
      {children}
    </h2>
  )
}
Heading2.displayName = 'Heading2'

type Heading3Props = PropsWithChildrenAndId & {
  children: ReactNode
  id?: string
}

const Heading3: FC<Heading3Props> = ({children, id}) => {
  return (
    <h3 id={id} className="py-2 font-medium">
      <span>{children}</span>
    </h3>
  )
}
Heading3.displayName = 'Heading3'

const Paragraph: FC<PropsWithChildrenAndId> = ({children, id}) => {
  return (
    <p id={id} className="py-2">
      {children}
    </p>
  )
}
Paragraph.displayName = 'Paragraph'

const List: FC<PropsWithChildrenAndId> = ({children, id}) => {
  return (
    <ul id={id} className="my-2 list-disc">
      {children}
    </ul>
  )
}
List.displayName = 'List'

const ListItem: FC<PropsWithChildrenAndId> = ({children, id}) => {
  return (
    <li id={id} className="ml-8 py-1">
      {children}
    </li>
  )
}
ListItem.displayName = 'ListItem'

export {Heading1, Heading2, Heading3, Paragraph, List, ListItem}
